/**
 * Created by esenckewitch on 30.07.2026
 */

const NewCrossPromoWindow = Prefab.createWindow("newcrosspromo", "newcrosspromowindow_prefab_json");
